export enum FolderType {
  individual = 1,
  pedigree = 6,
  pedigreeSpreadsheet = 2,
}
